import React from 'react';

import { Icon } from '@fluentui/react/lib/Icon';
import { List } from '@fluentui/react/lib/List';
import { IconButton, ActionButton } from '@fluentui/react/lib/Button';
import { TooltipHost } from '@fluentui/react/lib/Tooltip';
import { DirectionalHint } from '@fluentui/react/lib/Callout';
import {
  Shimmer,
  ShimmerElementType
} from '@fluentui/react/lib/Shimmer';

import { ICommunityMember,
  MemberStatus,
  MemberType,
  CommunityRole
} from '../../Community/types';

interface Props {
  adminMembers: any[];
  communityId: string;
  initialValues: any;
  tooltips: any;
  memberType: any;
  azureId: string;
  linkedAccountAzureId: string;

  requestChangeMember(communityId: string, id: any, flag: boolean): void;
  requestDeleteMember(communityId: string, id: any, flag: boolean): void;
  viewCommunityMembers(communityId: string): void;
  CommunityMemberPersona: any;
  // requestChangeMember(event: React.MouseEvent<HTMLElement>): void;
}

const MembersComponent = (props: Props) => {
  const {
    communityId,
    tooltips,
    adminMembers,
    initialValues,
    memberType,
    azureId,
    linkedAccountAzureId,

    requestChangeMember,
    requestDeleteMember,
    viewCommunityMembers,
    CommunityMemberPersona,
  } = props;

  const onPromote = (event: React.MouseEvent<HTMLElement>) => {
    requestChangeMember(communityId, event.currentTarget.id, true);
    event.preventDefault();
    event.stopPropagation();
  };

  const onDemote = (event) => {
    requestChangeMember(communityId, event.currentTarget.id, false);
    event.preventDefault();
    event.stopPropagation();
  };

  const onRemove = (event) => {
    requestDeleteMember(communityId, event.currentTarget.id, true);
    event.preventDefault();
    event.stopPropagation();
  };

  const onViewAllMembers = () => {
    viewCommunityMembers(communityId);
  };

  const onRenderCell = (item: ICommunityMember, index, isScrolling) => {
    const status = item.memberStatus;

    return (
      <div className='memberItem' data-is-focusable={true}>
        <div className='memberPersona'>
          <CommunityMemberPersona
            community={initialValues}
            item={item}
            directionalHint={DirectionalHint.leftCenter}
            gapSpace={-650}
            coinSize={40}
          />
        </div>
        <div className='memberTools'>
          {azureId !== item.azureId &&
            item.azureId !== linkedAccountAzureId &&
            memberType !== MemberType.Sponsored &&
            status !== MemberStatus.Inactive &&
            status.indexOf('Pending') === -1 && (
              <TooltipHost content='Message member'>
                <IconButton
                  id={item.azureId}
                  iconProps={{
                    iconName: 'Message',
                    styles: {
                      root: {
                        fontSize: 24,
                        height: 24,
                        width: 24,
                        lineHeight: 24,
                        backgroundColor: '#eaeaea',
                        boxSizing: 'content-box',
                        marginLeft: 0,
                        padding: 8,
                        borderRadius: 8
                      }
                    }
                  }}
                  href={`https://teams.microsoft.com/_#/conversations/8:orgid:${
                    item.accountType === 'Linked Account' && item.linkedAzureId
                      ? item.linkedAzureId
                      : item.azureId
                  }?ctx=chat`}
                  target='_blank'
                />
              </TooltipHost>
            )}

          {initialValues.isOwner &&
            item.role === CommunityRole.Owner &&
            item.azureId !== azureId && (
              <TooltipHost content={tooltips.MEMBERTOOLS_DEMOTE}>
                <IconButton
                  id={item.azureId}
                  iconProps={{ iconName: 'Down' }}
                  onClick={onDemote}
                  disabled={!initialValues.isCreated}
                />
              </TooltipHost>
            )}

          {initialValues.isOwner &&
            item.role === CommunityRole.Member &&
            status !== MemberStatus.Inactive &&
            item.memberType !== MemberType.Sponsored &&
            ((item.isGuest && item.linkedAzureId !== null) ||
              !item.isGuest) && (
              <TooltipHost content={tooltips.MEMBERTOOLS_PROMOTE}>
                <IconButton
                  id={item.azureId}
                  iconProps={{ iconName: 'Up' }}
                  onClick={onPromote}
                  disabled={!initialValues.isCreated}
                />
              </TooltipHost>
            )}

          {initialValues.isOwner &&
            item.role !== CommunityRole.Owner &&
            item.azureId !== linkedAccountAzureId && (
              <TooltipHost content={tooltips.MEMBERTOOLS_REMOVE}>
                <IconButton
                  id={item.azureId}
                  className='memberItem-remove'
                  iconProps={{ iconName: 'StatusErrorFull' }}
                  onClick={onRemove}
                  disabled={!initialValues.isCreated}
                />
              </TooltipHost>
            )}
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      <Shimmer
        width={'100%'}
        isDataLoaded={adminMembers !== null}
        shimmerElements={[
          { type: ShimmerElementType.circle, width: 40, height: 40 },
          { type: ShimmerElementType.gap, width: 16 },
          { type: ShimmerElementType.line, height: 30 }
        ]}
      >
        <div className='communityPage-cellHeader'>
          <h2>Owners of this community</h2>
        </div>
        <div className='communityPage-owners'>
          <List
            items={adminMembers}
            onRenderCell={onRenderCell}
            className='communityOwners-list'
            style={{ flex: 6 }}
          />
          <div style={{ flex: 2 }} />
        </div>
      </Shimmer>
      <ActionButton
        className='button-see-all'
        onClick={onViewAllMembers}
      >
        See all members <Icon iconName='Forward' />
      </ActionButton>
    </React.Fragment>
  );
}

export default MembersComponent;